import type { JSXChild, JSXProps } from 'engine/index';

export function Table(props: JSXProps, children: JSXChild[]) {
	return (
		<table class="min-w-full border-collapse overflow-hidden rounded-md bg-white text-sm shadow-md dark:bg-gray-800" {...props}>
			{children}
		</table>
	);
}

export function TrHead(props: JSXProps, children: JSXChild[]) {
	return (
		<tr class="border-b border-gray-200 text-gray-800 dark:border-gray-700 dark:text-gray-100" {...props}>
			{children}
		</tr>
	);
}

export function TrBody(props: JSXProps, children: JSXChild[]) {
	return (
		<tr class={'data-href' in props ? 'cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700' : ''} {...props}>
			{children}
		</tr>
	);
}

export function Th(props: JSXProps, children: JSXChild[]) {
	return (
		<th class="p-3 text-left" {...props}>
			{children}
		</th>
	);
}

export function Td(props: JSXProps, children: JSXChild[]) {
	return (
		<td class="border-gray-200 p-3" {...props}>
			{children}
		</td>
	);
}
